import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import SuperAdmin from "./pages/SuperAdmin";
import LegalRequirements from "./pages/LegalRequirements";
import ISO14001 from "./pages/ISO14001";
import Waste from "./pages/Waste";
import Resources from "./pages/Resources";
import Audits from "./pages/Audits";
import Procedures from "./pages/Procedures";
import ESG from "./pages/ESG";
import Brigades from "./pages/Brigades";
import PEMEX from "./pages/PEMEX";
import SmartProjects from "./pages/SmartProjects";
import ADVC from "./pages/ADVC";
import Providers from "./pages/Providers";
import MapModule from "./pages/MapModule";
import Communication from "./pages/Communication";
import Studies from "./pages/Studies";
import AuditMode from "./pages/AuditMode";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";
import NotificationsInbox from "./pages/NotificationsInbox";
import ExternalAccess from "./pages/ExternalAccess";
import Formats from "./pages/Formats";
import WasteIntake from "./pages/WasteIntake";
import Repository from "./pages/Repository";
import InvestigationsModule from "./modules/investigations/InvestigationsModule";
import SuperAdminGate from "./components/SuperAdminGate";

/** Helper: envuelve una página con SuperAdminGate */
function withSuperAdminView(moduleName, endpoint, Page) {
  return (
    <SuperAdminGate moduleName={moduleName} apiEndpoint={endpoint}>
      <Page />
    </SuperAdminGate>
  );
}

function ProtectedRoutes() {
  const { user } = useAuth();
  if (user === null) {
    return <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
      <div className="spinner" />
    </div>;
  }
  if (!user) return <Login />;

  // Super Admin landing: si NO está auditando ningún tenant, su default es /superadmin
  // pero puede navegar a cualquier módulo del sidebar y ver la Vista Global (Cliente→Usuario→Documentos).
  const isSuperNoAudit = user.role === "SUPER_ADMIN" && !user.audit_tenant_id;

  return (
    <Routes>
      <Route path="/audit-mode" element={<AuditMode />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to={isSuperNoAudit ? "/superadmin" : "/dashboard"} replace />} />
        <Route path="/superadmin" element={<SuperAdmin />} />
        <Route path="/dashboard" element={
          isSuperNoAudit
            ? <SuperAdminGate moduleName="Panel Principal" apiEndpoint="/dashboard/superadmin/overview"><Dashboard /></SuperAdminGate>
            : <Dashboard />
        } />
        <Route path="/legal" element={withSuperAdminView("Requisitos Legales", "/legal/superadmin/overview", LegalRequirements)} />
        <Route path="/iso14001" element={withSuperAdminView("ISO 14001 / SGA", "/iso14001/superadmin/overview", ISO14001)} />
        <Route path="/waste" element={withSuperAdminView("Gestión de Residuos", "/waste/superadmin/overview", Waste)} />
        <Route path="/resources" element={withSuperAdminView("Consumo de Recursos", "/resources/superadmin/overview", Resources)} />
        <Route path="/audits" element={withSuperAdminView("Auditorías y RACS", "/audits/superadmin/overview", Audits)} />
        <Route path="/procedures" element={<Procedures />} />
        <Route path="/esg" element={withSuperAdminView("ESG - RSE", "/esg/superadmin/overview", ESG)} />
        <Route path="/brigades" element={withSuperAdminView("Respuesta a Emergencias", "/brigades/superadmin/overview", Brigades)} />
        <Route path="/pemex" element={withSuperAdminView("Soporte PEMEX", "/pemex/superadmin/overview", PEMEX)} />
        <Route path="/smart" element={withSuperAdminView("Smart Projects", "/smart/superadmin/overview", SmartProjects)} />
        <Route path="/advc" element={withSuperAdminView("Compromisos Voluntarios", "/advc/superadmin/overview", ADVC)} />
        <Route path="/providers" element={withSuperAdminView("Proveedores Ambientales", "/providers/superadmin/overview", Providers)} />
        <Route path="/map" element={withSuperAdminView("Mapa Interactivo", "/map/superadmin/overview", MapModule)} />
        <Route path="/communication" element={<Communication />} />
        <Route path="/studies" element={withSuperAdminView("Estudios Normativos", "/studies/superadmin/overview", Studies)} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/notifications" element={<NotificationsInbox />} />
        <Route path="/formats" element={withSuperAdminView("Formatos", "/formats/superadmin/overview", Formats)} />
        <Route path="/waste-intake" element={withSuperAdminView("Citas de Almacén", "/waste-intake/superadmin/overview", WasteIntake)} />
        <Route path="/repository" element={withSuperAdminView("Repositorio", "/repository/superadmin/overview", Repository)} />
        <Route path="/investigations" element={withSuperAdminView("Investigaciones HSEQ", "/investigations/superadmin/overview", InvestigationsModule)} />
        <Route path="*" element={<Navigate to={isSuperNoAudit ? "/superadmin" : "/dashboard"} replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/external/:token" element={<ExternalAccess />} />
          <Route path="/*" element={<ProtectedRoutes />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
